import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core';
import { HashRouteGuard } from './core/services/hash-route-guard.service';

const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
    },
    {
        path: 'DataCollectionAndStorage',
        loadComponent: () =>
            import('./pages/privacy-policy/privacy-policy.component').then(
                m => m.PrivacyPolicyComponent,
            ),
    },
    {
        path: 'consentdip/:guid',
        loadComponent: () =>
            import('./pages/consent-dip/consent-dip.component').then(m => m.ConsentDipComponent),
    },
    {
        path: 'set-password',
        loadComponent: () =>
            import('./auth/set-password/set-password.component').then(
                m => m.SetPasswordComponent,
            ),
    },
    {
        path: '404',
        loadComponent: () =>
            import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent),
    },
    {
        path: '',
        loadChildren: () => import('./page/page.module').then(m => m.PageModule),
        canActivate: [HashRouteGuard, AuthGuard],
    },
    {
        path: 'consent',
        loadComponent: () =>
            import('./auth/consent/consent.component').then(m => m.ConsentComponent),
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
